import { i18n } from '@/plugins/i18n'

export const companyTypes = {
    PAYSTAR: 1,
    CASPIAN: 2,
    // OXIN: 3,
    // ARIYA: 4,
    // AXIN: 5,
}

export const companyTypesStr = {
    PAYSTAR: i18n.t('accounting.company_type_paystar'),
    CASPIAN: i18n.t('accounting.company_type_caspian'),
    // OXIN: i18n.t('accounting.oxin'),
    // ARIYA: i18n.t('accounting.ariya'),
    // AXIN: i18n.t('accounting.axin'),

    get(company_type) {
        let company_type_str = null;

        Object.keys(companyTypes).forEach(function (item) {
            if(companyTypes[item] === company_type) {
                company_type_str = companyTypesStr[item];
            }
        });
        return company_type_str;
    }
}
